import React from 'react';
import { cn } from '../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  compact?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, compact, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex w-full border border-slate-300 bg-white font-body text-text-heading transition-interactive placeholder:text-text-muted',
          'focus:border-statura-green focus:outline-none focus:ring-[3px] focus:ring-statura-green/20',
          compact ? 'h-8 rounded-md px-2 text-sm' : 'h-11 rounded-xl px-4 py-2 text-sm',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
          // AFTER `className`: tailwind-merge is last-wins, so a caller passing
          // its own border utility silently discarded the error state and an
          // invalid field looked identical to a valid one.
          error && 'border-red-500 focus:border-red-500 focus:ring-red-100',
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

/**
 * Shared field-appearance tokens for NATIVE `<select>` / `<input>` controls that
 * must keep the native element (e.g. a select inside a server-action form
 * server-action where FormData submission is required and the JS `Select`
 * component — which emits no native `name` — would break it). Mirrors the
 * default (non-compact) `Input` look so native controls match platform fields.
 * Apply alongside any layout classes the caller already needs (margins, grid).
 */
export const nativeFieldClassName =
  'flex h-11 w-full rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-body text-text-heading transition-interactive focus:border-statura-green focus:outline-none focus:ring-[3px] focus:ring-statura-green/20 disabled:cursor-not-allowed disabled:opacity-50';

export { Input };
